import { APP_CONFIG } from "../constants/appConstants";

async function publicApi(path) {
  const res = await fetch(`${APP_CONFIG.ADMIN_API_BASE_URL}${path}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Failed to fetch content");
  return data;
}

export const contentService = {
  async listFaqs() {
    const data = await publicApi("/content/faqs");
    return data?.items || [];
  },
  async listStories() {
    const data = await publicApi("/content/stories");
    return data?.items || [];
  },
  async listHomeModules() {
    const data = await publicApi("/content/home-modules");
    return data?.items || [];
  },
  async listPricingPlans() {
    const data = await publicApi("/content/pricing-plans");
    return data?.items || [];
  },
  async listFutureItems() {
    const data = await publicApi("/content/future-items");
    return data?.items || [];
  },
  async getFutureMeta() {
    const data = await publicApi("/content/future-items");
    return { nearTermFocus: data?.nearTermFocus || "" };
  },
  async listContactFeatures() {
    const data = await publicApi("/content/contact-features");
    return data?.items || [];
  },
  async listContactChannels() {
    const data = await publicApi("/content/contact-channels");
    return data?.items || [];
  },
  async listAlertRules() {
    const data = await publicApi("/content/alert-rules");
    return data?.items || [];
  },
  async getPublicStats() {
    const data = await publicApi("/content/stats");
    return {
      activeDevices: Number(data?.activeDevices || 0),
      sensorsPerNode: Number(data?.sensorsPerNode || 3),
      registeredUsers: Number(data?.registeredUsers || 0),
      liveMonitoring: String(data?.liveMonitoring || "24/7"),
    };
  },
  async getBlock(key) {
    const data = await publicApi(`/content/blocks/${encodeURIComponent(key)}`);
    return data?.data || null;
  },
};

